import type { FC } from "react";
import type { HotelRoomRateViewProps } from "@b2bportal/core-types";

import { HotelRoomRates } from "@tenant/hotels";

export const HotelRateView: FC<HotelRoomRateViewProps> = ({
  product,
  priceDifference,
  isSelected,
}) => {
  return (
    <HotelRoomRates
      product={product}
      priceDifference={priceDifference}
      className={isSelected ? "selected" : undefined}
    />
  );
};
